import styled from '@emotion/styled';
import Icon from 'presentations/views/components/atoms/Icon';
import IconButton from 'presentations/views/components/atoms/IconButton';
import { fontSize, fontWeight } from 'presentations/views/styles';

type Props = {
  onClick: () => void;
  color: string;
};

export default function Compnent(props: Props) {
  return (
    <StyledContainer>
      <StyledBackIconButton onClick={props.onClick}>
        <StyledBackIcon
          iconColor={props.color}
          color="inherit"
          name="chevron-left"
          size={1.5}
        />
      </StyledBackIconButton>
    </StyledContainer>
  );
}

const StyledContainer = styled.div``;
const StyledBackIcon = styled(Icon)<{ iconColor: string }>`
  fill: ${({ iconColor }) => iconColor};
  font-weight: ${fontWeight('bold')};
`;
const StyledBackIconButton = styled(IconButton)`
  padding: 0;
`;
